import { writable } from "svelte/store";

export const initialProjectDetail = () => {
    return {
        projectTitle: "",
        shortDescription: "",
        coverImage: "",
        mediaUrls: {
            facebook: "",
            twitter: "",
            linkedin: "",
            instagram: "",
            telegram: "",
            youtube: "",
            twitch: "",
            discord: ""
        },
        story: "",
        rewards: "",
        rewardDistributionDate: "",
        projectDescription: "",
        briefDescription: "",
    }
}


const projectDetailPermissionless = () => {
    const { subscribe, update, set } = writable(initialProjectDetail())

    return {
        subscribe,
        setProjectDetail: ({ ...fields }) => update(n => ({ ...n, ...fields })),
        reset: () => set(initialProjectDetail())
    }
}

export const projectDetailStore = projectDetailPermissionless()

